// extracted by mini-css-extract-plugin
module.exports = {"Strong":"Strong__3Ea_d"};